import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import _ from 'lodash';
export default function GatewayWhiteListedRoutesInfoComponent({ handleFormWhitelistedRoutesItemChange, whitelistedRoutes, handleDelete }: any) {
  return (
    <>
      <div className="h-[500px] overflow-auto w-full bg-white p-4">
        <table className="w-full text-xs bg-red-50">
          <thead className="w-full border-y border-black border-opacity-20">
            <tr className="w-full text-left h-12">
              <th className="border-r-2  last:border-r-0 w-auto px-10">S.No</th>
              <th className="border-r-2  last:border-r-0 w-auto px-10">Route</th>
              {/* <th className="border-r-2  last:border-r-0 w-auto px-10">Value</th> */}
              <th className="border-r-2  last:border-r-0 w-auto px-10">Action</th>

            </tr>
          </thead>
          <tbody className="w-full bg-red-400">
            {_.map(whitelistedRoutes, (cardValue: any, index: any) => (
              <tr key={index} className="w-full cursor-pointer h-10 even:bg-[#F8F9FAFF] odd:bg-white">


                <td
                  className="px-6 pt-2 w-auto">
                  {index + 1}
                </td>
                <td
                  className="px-6 pt-2 w-auto">
                  <InputContainer

                    name="Name"
                    onValueChange={(event: any) => {
                      handleFormWhitelistedRoutesItemChange({
                        value: event.target.value,
                        field: 'Name',
                        idx: index
                      });
                    }}
                    type="text"
                    value={cardValue?.Name} />
                </td>
                {/* <td
                  className="px-6 pt-2 w-auto">
                  <InputContainer

                    name="Value"
                    onValueChange={(event: any) => {
                      handleFormWhitelistedRoutesItemChange({
                        value: event.target.value,
                        field: 'Value',
                        idx: index
                      });
                    }}
                    type="text"
                    value={cardValue?.Value} />
                </td> */}
                <td
                  className="px-6 w-auto">
                  {index !== whitelistedRoutes?.length -1 ?  <div className="text-red-500" onClick={() => handleDelete(index)}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} fill="none">
                      <path d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M9.5 16.5L9.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M14.5 16.5L14.5 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>

                  </div>: <div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#000000"} fill={"none"}>
                      <path d="M19.5 5.5L19.0982 12.0062M4.5 5.5L5.10461 15.5248C5.25945 18.0922 5.33688 19.3759 5.97868 20.299C6.296 20.7554 6.7048 21.1407 7.17905 21.4302C7.85035 21.84 8.68108 21.9631 10 22" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" />
                      <path d="M20 15L13 21.9995M20 22L13 15.0005" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3 5.5H21M16.0557 5.5L15.3731 4.09173C14.9196 3.15626 14.6928 2.68852 14.3017 2.39681C14.215 2.3321 14.1231 2.27454 14.027 2.2247C13.5939 2 13.0741 2 12.0345 2C10.9688 2 10.436 2 9.99568 2.23412C9.8981 2.28601 9.80498 2.3459 9.71729 2.41317C9.32164 2.7167 9.10063 3.20155 8.65861 4.17126L8.05292 5.5" stroke="#141B34" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                    </div>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  )
}